__turbopack_context__.v({
  "caption": "Figure-module__AgHcBa__caption",
  "image": "Figure-module__AgHcBa__image",
  "inner": "Figure-module__AgHcBa__inner",
  "root": "Figure-module__AgHcBa__root",
});
